import { builder } from "./builder";
import "./schema";

export const validator = builder.toValidator();
